export const coordinateEventName = 'coordinates-input-custom-event'

type CoordinateData = {
  x: number
  y: number
  z: number
}

export type CoordinateEvent = CustomEvent<CoordinateData>

function subscribeCoordinateEvent(event: CoordinateEvent) {
  // @ts-ignore
  document.addEventListener(coordinateEventName, event)
}

function unsubscribeCoordinateEvent(event: CoordinateEvent) {
  // @ts-ignore
  document.removeEventListener(coordinateEventName, event)
}

function publishCoordinateEvent(data: CoordinateData) {
  const event = new CustomEvent<CoordinateData>(coordinateEventName, { detail: data })
  document.dispatchEvent(event)
}

export { publishCoordinateEvent, subscribeCoordinateEvent, unsubscribeCoordinateEvent }
